import { createContext } from "react";

import type { ISharedDataApi } from "../shared";
import type { WeatherApi } from "../Weather/weather.api";

export type ApiContextValue = {
  // Used across all apps
  weatherApi: WeatherApi | null;
  dataApi: ISharedDataApi | null;
  // Only used in platform-web
  optimizationApi?: any | null;
};

export type ApiContextType = ApiContextValue;

export const ApiContext = createContext<ApiContextValue | null>(null);

// Main provider export
export const ApiProvider = ApiContext.Provider;

// Used incase of backward compatibility
export const MdslApiProvider = ApiContext.Provider;
